import { Component } from '@angular/core';

@Component({
    selector: 'app-coripet',
    templateUrl: './coripet.component.html',
    styleUrls: ['./coripet.component.css'],
    standalone: false
})
export class CoripetComponent {

  constructor() { }

}